"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const BlankCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: color,
      fillRule: "nonzero",
      transform: "translate(-189 -560)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M11.5 23C17.851 23 23 17.851 23 11.5S17.851 0 11.5 0 0 5.149 0 11.5 5.149 23 11.5 23zm0-2a9.5 9.5 0 110-19 9.5 9.5 0 010 19z",
        transform: "translate(189 560)"
      })
    })
  })]
});

BlankCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = BlankCircleIcon;
exports.default = _default;